import { Icon } from '@dixa/lib-shared-habla';
import { basicBlockActions } from 'articleEditor/utils/actions';
import cx from 'classnames';
import { useEditableProps } from 'lib-knowledge-document-structure/plate/common';
import { useMemo } from 'react';
import { mergeRefs } from 'react-merge-refs';

import { SortableBlockWrapper } from '../baseBlock';
import s from '../baseBlock/block.module.scss';
import { UploadFormProps, VideoBlockProps } from './videoBlock';

type ImageBlockPlaceholderProps = VideoBlockProps & UploadFormProps;

export default function VideoBlockPlaceholder({
  attributes,
  element,
  openUploadMenu,
  uploadRef,
  uploadMenuGetReferenceProps: uploadGetReferenceProps,
  children,
}: ImageBlockPlaceholderProps): JSX.Element {
  const blockActions = useMemo(() => [...basicBlockActions], []);
  const { readOnly } = useEditableProps();
  if (readOnly) return <></>;

  // TODO: update class names
  return (
    <SortableBlockWrapper
      className={s['blockImagePlaceholder']}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...uploadGetReferenceProps({
          ...attributes,
          ref: mergeRefs([uploadRef, attributes.ref]),
          className: cx(s['mediaUploadArea'], s['blockContent']),
          contentEditable: false,
          onClick: openUploadMenu,
        })}
      >
        <Icon className={s['mediaUploadAreaIcon']} name="image" />
        <div className={s['mediaUploadAreaText']}>Embed a video...</div>
      </div>
      {children}
    </SortableBlockWrapper>
  );
}
